import React from 'react';
import SystemAdminLayout from '../layout/SystemAdminLayout';
import { adminCard, adminSectionTitle, adminMutedText } from '../layout/adminStyles';

const SystemAdminIndexPage = () => {
  return (
    <SystemAdminLayout>
      <div className={adminCard}>
        <h2 className={adminSectionTitle}>全体管理ダッシュボード</h2>
        <p className={`${adminMutedText} mb-2`}>
          システム管理者（admin）としてログインしています。
        </p>
        <p className={adminMutedText}>
          店舗向け管理画面とは別の、全体管理用ページです。
        </p>
      </div>
    </SystemAdminLayout>
  );
};

export default SystemAdminIndexPage;
